import type { BottegaLabels } from '@components/Bottegas/Bottega/Bottega'
import type { BottegaBlock, LocationCoordinates } from '@velasca/types'
import { calcDistanceString } from '@velasca/utils/calc-distance-string'
import { $bottega_blocks, $page_bottega, google } from '@velasca/utils/globals'
import { sanitizeHTML } from '@velasca/utils/sanitize-html'
import { useBottega } from '../BottegaProvider'
import Bottega from '../Bottegas/Bottega'

const NearestBottega = () => {
  const bottega = useBottega()

  if (!bottega) {
    return null
  }

  const { currentUserLocation } = bottega

  const calculateDistance = (place: LocationCoordinates) => {
    if (!google) {
      console.error("Couldn't access google global object.")

      return 0
    }

    return google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(
        //@ts-expect-error
        currentUserLocation.geometry?.location.lat(),
        currentUserLocation.geometry?.location.lng(),
      ),
      new google.maps.LatLng(Number(place.lat), Number(place.lng)),
    )
  }

  if (typeof currentUserLocation.geometry !== 'undefined') {
    $bottega_blocks.sort((bottegaA: BottegaBlock, bottegaB: BottegaBlock) => {
      const aDistance = calculateDistance(bottegaA)
      const bDistance = calculateDistance(bottegaB)

      if (aDistance < bDistance) {
        return -1
      }
      if (aDistance > bDistance) {
        return 1
      }

      return 0
    })
  }

  return typeof currentUserLocation.geometry !== 'undefined' ? (
    <div className="bottega-list nearest col-md-10 col-md-offset-1">
      <div className="nearest-bottega">
        <p
          dangerouslySetInnerHTML={sanitizeHTML(
            $page_bottega.label_nearest_bottega.replaceAll(
              '%distanza%',
              calcDistanceString(calculateDistance($bottega_blocks[0])),
            ),
          )}
        ></p>
      </div>
      <Bottega
        labels={$page_bottega as unknown as BottegaLabels}
        bottega={$bottega_blocks[0]}
      />
    </div>
  ) : null
}

export default NearestBottega
